import clsx from "clsx";

/**
 * A helper component used within BookingCard to render a line of the card, where each line contains a label and a value.
 *
 * @param {Object} props
 * @param {string} props.label - The label of the given property
 * @param {string} props.value - The value of the given property
 * @param {string} props.className - Extra CSS classes for the line wrapper
 * @returns {JSX.Element}
 */

const BookingLine = ({ label, value, className }) => {
  return (
    <div className={clsx("flex justify-between my-1 w-full", className)}>
      <p className="basis-1/2 text-text_lightdark_grey font-light">{label}</p>
      <p className="basis-1/2 font-semibold truncate">{value}</p>
    </div>
  );
};

export default BookingLine;
